import React from 'react';
import Modal from 'components/modal';
import { ReportMeaningsWrapper } from '@seedlang/hoc';
import { AppUI } from '@seedlang/state';
import ReportMeaningsForm from 'components/vocab/report_meanings_form';

class ReportMeaningsModal extends React.Component {
  render() {
    if (!this.props.open) return null;

    return (
      <Modal
        width={AppUI.layout.isMobile ? '92%' : '600px'}
        onCloseModal={this.props.close}
        hideCloseIcon={false}
        title="Report a Problem"
        gradient
      >
        <ReportMeaningsForm
          {...this.props}
        />
      </Modal>
    );
  }
}

export default ReportMeaningsWrapper(ReportMeaningsModal);
